import colors from './colors';

// Shared CARIACA geometry and semantic colors; retain the existing brand palette.
export const uiTokens = {
  radius: { control: '10px', card: '16px', dialog: '20px' },
  controlHeight: { small: '32px', medium: '40px', large: '44px' },
  space: { page: '24px', section: '20px', card: '20px', gap: '16px' },
  color: {
    primary: colors.blue600,
    primaryHover: colors.blue700,
    primarySoft: colors.blue50,
    surface: colors.white,
    canvas: colors.gray50,
    border: colors.gray100,
    borderStrong: colors.gray200,
    text: colors.gray900,
    textMuted: colors.gray500,
    disabled: colors.gray100,
    danger: colors.warning,
  },
} as const;

export default uiTokens;
